export const scrollToTop = () =>
  scrollToPosition(0)

export const scrollToRef = (ref) =>
  scrollToNode(ref.current)

// this works in some cases where scrollIntoView() doesn't ¯\_(ツ)_/¯
export const scrollToNode = (node) =>
  scrollToPosition(absTopOffset(node))

const absTopOffset = (el) =>
  el.offsetParent ? el.offsetParent.offsetTop + absTopOffset(el.offsetParent) : 0

export const scrollToPosition = (top) => {
  if (window.scrollTo !== undefined) {
    try {
      window.scrollTo({ behavior: 'smooth', left: 0, top })
    } catch (err) {
      window.scroll(0, top)
    }
  }
}
